import { ProductTypesFilter } from '@/types';
import { ProductTypesActionTypes, ProductTypesFilterSetAction } from '../types';

export const setFilterAction = (filter: ProductTypesFilter): ProductTypesFilterSetAction => ({
  type: ProductTypesActionTypes.PRODUCT_TYPES_FILTER_SET,
  filter,
});
